class InputRadioButtons extends DummyElement {
  #buttons;

  constructor() {
    super();

    const shadow = this.attachShadow({ mode: "closed" });
    const container = document.createElement("div");
    // container.classList.add("w-full", "my-15");
    container.classList.add("w-full");
    const label = document.createElement("label");
    const span = document.createElement("span");
    span.innerText = this.label;
    const buttons = document.createElement("div");
    buttons.classList.add("flex", "flex-wrap");
    /*
      `label` is what the customer sees on the button; `key` (optional)
      is the technical value submitted as the line-item property. The
      draft-order app matches this property value (lowercased) against
      the shop-metafield keys (e.g. "edelstahl_platten"), so options
      whose display label differs from the metafield key MUST provide
      a `key` in the options JSON. Without `key` the label is used, as
      before.
    */
    buttons.innerHTML = this.options
      .map(
        ({ label, postfix = "", key }, i) =>
          `<span><input id="${this.name}-${i + 1}" type="radio" name="${
            this.name
          }" value="${i}" ${i === 0 ? "checked" : ""}/><label for="${
            this.name
          }-${
            i + 1
          }" class="btn btn--style1" value="${key || label}">${label}${postfix}</label></span>`
      )
      .join("");
    this.#buttons = buttons;
    label.appendChild(span);
    label.appendChild(buttons);
    container.appendChild(label);
    shadow.appendChild(container);

    const style = document.createElement("style");
    style.textContent = this.#generateStyle();

    shadow.appendChild(style);

    this.#buttons
      .querySelectorAll("input")
      .forEach((input) =>
        input.addEventListener("change", this.#handleInputChange.bind(this))
      );
    this.value = this.#buttons.querySelector("input:checked").value;
    this.setAttribute("data-property", this.label);

    if (this.defaultValue) {
      const defaultCheckbox = this.#buttons.querySelector(
        `#${this.name}-${this.defaultValue}`
      );
      if (defaultCheckbox) {
        this.value = parseInt(this.defaultValue) - 1;
        defaultCheckbox.checked = true;
      }
    }
  }

  connectedCallback() {}

  disconnectedCallback() {
    this.buttons
      .querySelectorAll("input")
      .forEach((input) =>
        input.addEventListener("change", this.#handleInputChange)
      );
  }

  get label() {
    return this.getAttribute("label");
  }

  get options() {
    return JSON.parse(JSON.parse(this.getAttribute("options")));
  }

  get name() {
    return this.getAttribute("name");
  }

  get value() {
    return this.#buttons
      .querySelector("input:checked + label")
      .getAttribute("value");
  }

  set value(newValue) {
    let currentValue = newValue || 0;
    currentValue = isNaN(currentValue) ? 0 : parseInt(currentValue);
    Object.entries(this.options[currentValue].value).forEach(([key, value]) =>
      PriceRenderer.modifySymbol(key, value)
    );
  }

  #handleInputChange({ currentTarget: { value } }) {
    this.value = value;
  }

  #generateStyle() {
    return `
    * {
        box-sizing: border-box;
    }
    .w-full{
        width: 100%;
        position: relative;
    }
    .my-15 {
        margin-top: 1.5rem;
        margin-bottom: 1.5rem;
    }
    .flex-wrap {
        flex-wrap: wrap;
    }
    .flex {
        display: flex;
        gap: 1rem;
    }

    input[type="radio"]{
      display: none;
    }


    .btn--style1 {
      appearance: none;
      background-color: #fff;
      border-radius: 3px;
      border: 1px solid #c7c7c7;
      color: #101010;
      cursor: pointer;
      display: block;
      font-size: 1.5rem;
      font-weight: normal;
      line-height: 1.5;
      margin-top: 0;
      padding: 0.75rem 1.5rem;
      position: relative;
      text-transform: none;
      transition: background-color .15s ease-out,border-color .15s ease-out,box-shadow .15s ease-out,color .15s ease-out,transform .15s ease-out,-webkit-box-shadow .15s ease-out,-webkit-transform .15s ease-out;
      width: 100%;
    }

    input[type="radio"]:checked + .btn--style1 {

      /*
      background-color: #ff0f33;
      border-color: #ff0f33;
      */

      background-color: var(--color-red-primary);
      border-color: var(--color-red-primary);
      color: #fff;
    }

    label  {
        display: block;
        font-weight: 500;
        margin-top: 0;
        position: relative;
        color: #101010;
        font-size: 1.3rem;
    }

    label > span {
        display:block;
        margin-bottom: 0.5rem;
    }
    `;
  }
}

customElements.define("input-radio-buttons", InputRadioButtons);
